module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_2.16e92767.png";